/* eslint-disable camelcase */
/* eslint-disable radix */
/* eslint-disable angular/controller-as */

import {identifyUser} from '../segment'
import {wrap} from '../shared/loading-overlay'
import {formatQualificationDateToPqe} from '../shared/services/format-pqe'
;(function module() {
  angular.module('app.ui.form.ctrls').controller('MatchesController', [
    '$location',
    '$scope',
    'logger',
    '$anchorScroll',
    'usSpinnerService',
    '$timeout',
    'practiceAreaService',
    'locationsGenericService',
    'MatchesApi',
    'SharedApi',
    'CandidateProfileApi',
    '$uibModal',
    'userService',
    'socket',
    'sharedProperties',
    function controller(
      $location,
      $scope,
      logger,
      $anchorScroll,
      usSpinnerService,
      $timeout,
      practiceAreaService,
      locationsGenericService,
      MatchesApi,
      SharedApi,
      CandidateProfileApi,
      $uibModal,
      userService,
      socket,
      sharedProperties
    ) {
      let vm = this

      $scope.$on('candidate:wizard:completed', async () => {
        const go = async () => {
          console.debug('wizard completed!')
          const reload = () => {
            vm.initializeMatches()
          }

          await $timeout(reload, 1000)
        }

        await wrap(go)
      })
      socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', async candidateId => {
        $timeout(() => {
          if (
            vm.user.id === candidateId &&
            $location.url().contains('matches')
          ) {
            vm.initializeMatches()
          }
        }, 2000)
      })

      socket.on('CANDIDATE_RECOMMENDATION_GENERATED', async candidateId => {
        $timeout(() => {
          if (
            vm.user.id === candidateId &&
            $location.url().contains('matches')
          ) {
            vm.select(vm.currentPage)
          }
        }, 1500)
      })

      socket.on('CANDIDATE_ASSIGNED_AGENT_UPDATE', async candidateId => {
        $timeout(async () => {
          if (
            vm.user.id === candidateId &&
            $location.url().contains('matches')
          ) {
            const {data: candidate} = await CandidateProfileApi.getUserProfile(
              vm.user.id
            )
            vm.candidateAgent = await sharedProperties.getAgentDetails(
              candidate.agent
            )
            $scope.$applyAsync()
          }
        }, 1000)
      })

      socket.on('CANDIDATE_PROFILE_AGENT_UPDATE', async candidateId => {
        $timeout(async () => {
          if (
            vm.user.id === candidateId &&
            $location.url().contains('matches')
          ) {
            const {data: candidate} = await CandidateProfileApi.getUserProfile(
              vm.user.id
            )
            vm.candidateAgent = await sharedProperties.getAgentDetails(
              candidate.agent
            )
            $scope.$applyAsync()
          }
        }, 1000)
      })
      vm.candidateMatchesData = []
      vm.currentPage = 1
      vm.noJob = false
      vm.selectedPracticeArea = undefined
      vm.selectedLocations = undefined
      vm.selectedContracts = undefined
      vm.selectedEmployerTypes = undefined
      vm.selectedOccupations = undefined
      vm.minPqe = undefined
      vm.maxPqe = undefined
      vm.candidateLocations = []
      vm.candidateSpecialties = []
      vm.fetchHiddenJobs = false
      vm.numPerPageOpt = [10, 20, 50]
      vm.numPerPage = vm.numPerPageOpt[2]
      vm.totalPositions = 0
      vm.countRefreshReq = false
      vm.today = new Date()
      vm.picSrc = 'images/firm-logo-default.jpg'
      vm.hideJobFilterButton = false
      vm.toolTipText = 'You have already shared your profile.'
      vm.pageName = 'matches'
      vm.filterPQE = '0;11'

      vm.options = {
        round: 1,
        from: 0,
        to: 11,
        step: 0.5,
        dimension: '+ PQE',
        scale: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+'],
      }
      vm.spinnerActive = false
      vm.alertOne =
        'Unfortunately there are no current opportunities on LexStep for which your profile is a relevant match.  You will be alerted when a relevant opportunity match arises.  You can also edit your '
      vm.alertTwo =
        ' to refine your search parameters and reveal potential opportunities.'

      vm.startSpin = () => {
        if (!vm.spinnerActive) {
          usSpinnerService.spin('spinner-2')
          vm.spinnerActive = true
        }
      }

      vm.stopSpin = () => {
        if (vm.spinnerActive) {
          usSpinnerService.stop('spinner-2')
          vm.spinnerActive = false
        }
      }

      vm.hidePositionFromUI = position => {
        position.isHidden = true
        vm.hiddenPositions++
        vm['jobRow' + position.id] = 'zoomOutRight'

        try {
          analytics.track('Selected Job Not For Me', {
            lawyer_id: identifyUser().id,
            job_id: position.id,
            job_title: position.title,
            job_max_pqe: position.lawPreferences.maxPqe,
            job_min_pqe: position.lawPreferences.minPqe,
            job_contract: position.lawPreferences.contractTypeId,
            job_role: position.occupationId,
            employer_type:
              position.employerTypes &&
              position.employerTypes.length > 0 &&
              position.employerTypes[0] &&
              position.employerTypes[0].name,
            firm_id: position.employerId,
            firm_name: position.employer.name,
            page: 'In-House',
            name: `${vm.candidate.firstName} ${vm.candidate.lastName}`,
          })
          // eslint-disable-next-line unicorn/catch-error-name, unicorn/prevent-abbreviations
        } catch (e) {
          console.error('Track: Selected Job Not For Me', e)
        }

        $timeout(() => {
          vm.candidateMatchesData = vm.candidateMatchesData.filter(
            ({id}) => id !== position.id
          )

          vm.noJob = vm.candidateMatchesData.length <= 0
          vm.totalPositions--
          vm.countRefreshReq = true
          vm['jobRow' + position.id] = ''
        }, 300)
      }

      vm.hideEmployerFromUI = position => {
        position.expanded = false
        const hiddenEmployerPositions = vm.candidateMatchesData.filter(
          ({employerId}) => employerId === position.employerId
        )
        hiddenEmployerPositions.forEach(hiddenEmployerPosition => {
          vm['jobRow' + hiddenEmployerPosition.id] = 'zoomOutRight'
        })
        try {
          analytics.track('Selected Firm Not For Me', {
            lawyer_id: identifyUser().id,
            employer_type:
              position.employerTypes &&
              position.employerTypes.length > 0 &&
              position.employerTypes[0] &&
              position.employerTypes[0].name,
            firm_id: position.employerId,
            firm_name: position.employer.name,
            page: 'In-House',
            name: `${vm.candidate.firstName} ${vm.candidate.lastName}`,
          })
          // eslint-disable-next-line unicorn/catch-error-name, unicorn/prevent-abbreviations
        } catch (e) {
          console.error('Track: Selected Firm Not For Me Error', e)
        }

        $timeout(() => {
          hiddenEmployerPositions.forEach(hiddenEmployerPosition => {
            vm.candidateMatchesData = vm.candidateMatchesData.filter(
              ({id}) => id !== hiddenEmployerPosition.id
            )
            vm['jobRow' + hiddenEmployerPosition.id] = ''
          })

          vm.noJob = vm.candidateMatchesData.length <= 0
          vm.totalPositions =
            Number.parseInt(vm.totalPositions) -
            Number.parseInt(hiddenEmployerPositions.length)
          vm.hiddenPositions =
            Number.parseInt(vm.hiddenPositions) +
            Number.parseInt(hiddenEmployerPositions.length)
          vm.countRefreshReq = true
        }, 300)
      }

      vm.unHidePosition = async position => {
        if (position.employerHidden && !position.positionHidden) {
          const payload = {
            employerIds: [Number.parseInt(position.employerId)],
            updateValue: false,
          }
          try {
            await MatchesApi.unHideCandidateEmployer(position.userId, payload)
            position.expanded = false
            const unHiddenEmployerPositions = vm.candidateMatchesData.filter(
              candidateMatch =>
                candidateMatch.employerId === position.employerId &&
                !candidateMatch.positionHidden
            )
            vm.candidateMatchesData.forEach(candidateMatch => {
              if (candidateMatch.employerId === position.employerId) {
                candidateMatch.employerHidden = false
              }
            })
            unHiddenEmployerPositions.forEach(unHiddenEmployerPosition => {
              vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft'
            })
            $scope.$apply()

            $timeout(() => {
              unHiddenEmployerPositions.forEach(unHiddenEmployerPosition => {
                vm.candidateMatchesData = vm.candidateMatchesData.filter(
                  ({id}) => id !== unHiddenEmployerPosition.id
                )
                vm['jobRow' + unHiddenEmployerPosition.id] = ''
              })

              vm.noJob = vm.candidateMatchesData.length <= 0
              vm.totalPositions =
                Number.parseInt(vm.totalPositions) +
                Number.parseInt(unHiddenEmployerPositions.length)
              vm.hiddenPositions =
                Number.parseInt(vm.hiddenPositions) -
                Number.parseInt(unHiddenEmployerPositions.length)
              vm.countRefreshReq = true
            }, 500)
          } catch (error) {
            vm['jobRow' + position.id] = 'fadeIn'
            logger.notify('error', `somthing went wrong: ${error.statusText}`)
          }
        } else if (!position.employerHidden && position.positionHidden) {
          const payload = {
            positionIds: [Number.parseInt(position.id)],
            hide: false,
            reason: ' ',
          }
          try {
            await MatchesApi.unHideCandidatePosition(position.userId, payload)
            position.isHidden = true
            vm.totalPositions++
            vm['jobRow' + position.id] = 'zoomOutLeft'
            $scope.$apply()
            $timeout(() => {
              vm.candidateMatchesData = vm.candidateMatchesData.filter(
                ({id}) => id !== position.id
              )
              vm.noJob = vm.candidateMatchesData.length <= 0
              vm.hiddenPositions--
              vm.countRefreshReq = true
              vm['jobRow' + position.id] = ''
            }, 500)
          } catch (error) {
            vm['jobRow' + position.id] = 'fadeIn'

            logger.notify('error', `somthing went wrong: ${error.statusText}`)
          }
        } else if (position.employerHidden && position.positionHidden) {
          const positionUnHidePayLoad = {
            positionIds: [Number.parseInt(position.id)],
            hide: false,
            reason: ' ',
          }
          const employerUnHidePayLoad = {
            employerIds: [Number.parseInt(position.employerId)],
            updateValue: false,
          }
          try {
            await MatchesApi.unHideCandidatePosition(
              position.userId,
              positionUnHidePayLoad
            )
            await MatchesApi.unHideCandidateEmployer(
              position.userId,
              employerUnHidePayLoad
            )
            vm.candidateMatchesData.forEach(candidateMatch => {
              if (candidateMatch.employerId === position.employerId) {
                candidateMatch.employerHidden = false
              }
            })

            position.isHidden = true
            const unHiddenEmployerPositions = vm.candidateMatchesData.filter(
              externalMatch =>
                externalMatch.employerId === position.employerId &&
                !externalMatch.positionHidden
            )
            unHiddenEmployerPositions.forEach(unHiddenEmployerPosition => {
              vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft'
            })
            vm['jobRow' + position.id] = 'zoomOutLeft'
            $scope.$apply()
            $timeout(() => {
              vm.candidateMatchesData = vm.candidateMatchesData.filter(
                ({id}) => id !== position.id
              )

              unHiddenEmployerPositions.forEach(unHiddenEmployerPosition => {
                vm.candidateMatchesData = vm.candidateMatchesData.filter(
                  ({id}) => id !== unHiddenEmployerPosition.id
                )
                vm['jobRow' + unHiddenEmployerPosition.id] = ''
              })
              vm.noJob = vm.candidateMatchesData.length <= 0
              vm.totalPositions =
                Number.parseInt(vm.totalPositions) +
                Number.parseInt(unHiddenEmployerPositions.length) +
                1
              vm.hiddenPositions =
                Number.parseInt(vm.hiddenPositions) -
                Number.parseInt(unHiddenEmployerPositions.length) -
                1
              vm.countRefreshReq = true
              vm['jobRow' + position.id] = ''
            }, 500)
          } catch (error) {
            vm['jobRow' + position.id] = 'fadeIn'

            logger.notify('error', `somthing went wrong: ${error.statusText}`)
          }
        }
      }

      vm.getAllEmployerLogos = matches => {
        matches.map(async match => {
          const {employer} = match
          if (employer.logo) {
            employer.logoSrc = `${process.env.PUBLIC_BUCKET_URL}/employers/${match.employerId}/logo/${employer.logo}`
            return employer
          }

          employer.logoSrc = vm.picSrc
          return employer
        })
        $scope.$apply()
      }

      vm.getCandidateMatches = async (id, payload) => {
        try {
          vm.startSpin()

          // Console.debug('getCandidateMatches: payload', payload)
          console.debug('getCandidateMatches: vm', vm)

          const {
            data: candidateMatchesData,
          } = await MatchesApi.getCandidateMatchesData(id, payload)

          vm.candidateMatchesData = candidateMatchesData.positions
          vm.noJob = vm.candidateMatchesData.length <= 0
          vm.positionsCount = candidateMatchesData.positionsCount
          vm.totalPositions =
            vm.positionsCount.totalPositions - vm.positionsCount.hiddenPositions
          vm.hiddenPositions = vm.positionsCount.hiddenPositions

          vm.candidateMatchesData.forEach(async position => {
            position.expanded = false
            vm.formatPositionDescription(position)
            vm.checkPositionIsNew(position)
            position.locations =
              position.locations.length > 0
                ? vm.locationsList
                    .filter(({id}) =>
                      position.locations.find(location => location === id)
                    )
                    .map(location => ({
                      name: location.name,
                      parent: location.parent,
                      color: location.country.region.color,
                    }))
                : []
          })
          vm.getAllEmployerLogos(vm.candidateMatchesData)
          vm.applyFilterCheck = true
          vm.stopSpin()
          vm.disabledToolTip(vm.candidate)
          $scope.$applyAsync()
        } catch (error) {
          vm.stopSpin()
          logger.notify('error', `something went wrong: ${error.statusText}`)
        }
      }

      vm.select = async page => {
        vm.currentPage = page

        console.debug(
          'matches.select: selectedEmployerTypes =',
          vm.selectedEmployerTypes,
          'candidate',
          vm.candidate
        )

        const preferences = {
          occupations: vm.candidate.occupations
            ? vm.candidate.occupations.map(item => item.id)
            : [],
        }

        console.debug('matches.select: preferences =', preferences)

        const payload = {
          limit: vm.numPerPage,
          page: page,
          hiddenPositions: vm.fetchHiddenJobs,
          practiceAreas: vm.selectedPracticeArea
            ? vm.selectedPracticeArea.length > 0
              ? vm.selectedPracticeArea.map(({id}) => id)
              : [0]
            : undefined,
          locations: vm.selectedLocations
            ? vm.selectedLocations.length > 0
              ? vm.selectedLocations.map(({id}) => id)
              : [0]
            : undefined,
          minPqe: vm.minPqe,
          maxPqe: vm.maxPqe,

          employerTypes: vm.selectedEmployerTypes
            ? vm.selectedEmployerTypes.length > 0
              ? vm.selectedEmployerTypes.map(({id}) => id)
              : [0]
            : undefined,

          contractTypes: vm.contractTypes
            ? vm.contractTypes.length > 0
              ? vm.contractTypes.map(({id}) => id)
              : [1]
            : undefined,

          occupations: vm.selectedOccupations
            ? vm.selectedOccupations.length > 0
              ? vm.selectedOccupations.map(({id}) => id)
              : [0]
            : undefined,
          positionTypes: ['Regular', 'Custom'],
        }

        await vm.getCandidateMatches(
          vm.user.id,
          _.extend(payload, {
            occupations: payload.occupations
              ? payload.occupations.filter(id =>
                  preferences.occupations.includes(id)
                )
              : preferences.occupations,
          })
        )
      }

      vm.onNumPerPageChange = async () => {
        await vm.select(1)
        vm.currentPage = 1
      }

      vm.OnChangePracticeArea = async (event, selectedPracticeArea) => {
        if (event) {
          event.stopPropagation()
        } else {
          vm.selectedPracticeArea = selectedPracticeArea
          if (vm.selectedPracticeArea) {
            try {
              analytics.track('Practice Areas Filter Selected', {
                // eslint-disable-next-line camelcase
                lawyer_id: vm.user.id,
                // eslint-disable-next-line camelcase
                filtered_practice_area: vm.selectedPracticeArea.name,
                page: 'In-House',
                name: `${vm.candidate.firstName} ${vm.candidate.lastName}`,
              })
            } catch (error) {
              console.error('In-House', error)
            }

            await vm.select(vm.currentPage)
            vm.applyFilterCheck = false
          }
        }
      }

      vm.onChangeLocation = async (event, selectedLocations) => {
        if (event) {
          event.stopPropagation()
        } else {
          vm.selectedLocations = selectedLocations
          if (vm.selectedLocations) {
            try {
              analytics.track('Practice Areas Filter Selected', {
                // eslint-disable-next-line camelcase
                lawyer_id: vm.user.id,
                // eslint-disable-next-line camelcase
                filtered_location: vm.selectedLocations.name,
                page: 'In-House',
                name: `${vm.candidate.firstName} ${vm.candidate.lastName}`,
              })
            } catch (error) {
              console.error('In-House', error)
            }

            await vm.select(vm.currentPage)
            vm.applyFilterCheck = false
          }
        }
      }

      vm.pqeChanged = async () => {
        let separator = vm.filterPQE.search(';')
        let minPqe = vm.filterPQE.slice(0, separator)
        let maxPqe = vm.filterPQE.slice(separator + 1, vm.filterPQE.length)
        vm.minPqe = minPqe
        vm.maxPqe = maxPqe

        try {
          analytics.track('PQE Filter Selected', {
            // eslint-disable-next-line camelcase
            lawyer_id: vm.user.id,
            // eslint-disable-next-line camelcase
            min_pqe: minPqe,
            // eslint-disable-next-line camelcase
            max_pqe: maxPqe,
            page: 'In-House',
          })
        } catch (error) {
          console.error('In-House', error)
        }

        await vm.select(vm.currentPage)
        vm.applyFilterCheck = false
      }

      vm.applyFilters = async type => {
        switch (type) {
          case 'employerType':
            vm.selectedEmployerTypes = vm.employerTypes.filter(
              employerType => employerType.ticked
            )
            await vm.select(vm.currentPage)
            vm.applyFilterCheck = false

            break
          case 'occupation':
            vm.selectedOccupations = vm.occupations.filter(
              occupation => occupation.ticked
            )
            await vm.select(vm.currentPage)
            vm.applyFilterCheck = false

            break
          case 'contract':
            vm.selectedContracts = vm.contractTypes.filter(
              contractType => contractType.ticked
            )
            await vm.select(vm.currentPage)
            vm.applyFilterCheck = false

            break
          default:
            break
        }
      }

      vm.hiddenJobFilter = async () => {
        vm.noJob = false
        if (vm.fetchHiddenJobs) {
          vm.fetchHiddenJobs = false
        } else {
          vm.fetchHiddenJobs = true
        }

        await vm.select(1)
      }

      vm.showJobs = position => {
        console.debug('showJobs')
        if (position.expanded) {
          console.debug('showJobs - hiding')
          position.expanded = false
        } else if (position.expanded === false) {
          console.debug('showJobs - showing', vm)
          try {
            const analyticsData = {
              eventCategory: 'post-user acquisition',
              eventAction: 'job - view',
              eventLabel: 'click',
              job_id: position.id,
              firm_name: position.employer.name,
              job_company: position.employer.name,
              firm_id: position.employerId,
              job_title: position.title,
              job_pqe: `${position.lawPreferences.minPqe} - ${position.lawPreferences.maxPqe}`,
              job_contract: position.contractTypeName,
              currentEmployerName: vm.candidate.employer.name,
              currentEmployerId: vm.candidate.employer.id,
              current_emp: vm.candidate.employer.name,
              Name: `${vm.candidate.firstName} ${vm.candidate.lastName}`,
              name: `${vm.candidate.firstName} ${vm.candidate.lastName}`,
            }
            analytics.track('job - view', analyticsData)
          } catch (error) {
            console.error('Track - show jobs error', error)
          }

          position.expanded = true
        }
      }

      vm.locationBackgroundColor = location => {
        const color = location.color
        const parent = location.parent
        const countryCode =
          Boolean(parent) && Boolean(parent.countryCode)
            ? parent.countryCode
            : ''
        if (countryCode === 'GB') {
          return 'london'
        }

        return color
      }

      vm.showMore = job => {
        job.isCollapsed = !job.isCollapsed
      }

      vm.jumpToLink = id => {
        var oldHash
        oldHash = $location.hash()
        $location.hash(id)
        $anchorScroll()
        $location.hash(oldHash)
      }

      vm.showLess = job => {
        job.isCollapsed = !job.isCollapsed
        vm.jumpToLink(job.id)
      }

      vm.formatPositionDescription = position => {
        position.isCollapsed = true
        position.moreDetail = true
        if (position.description !== null) {
          if (position.description.length > 600) {
            position.showButton = true
          }
        }
      }

      vm.checkPositionIsNew = position => {
        const timeDiff = Math.abs(
          vm.today.getTime() - new Date(position.created).getTime()
        )

        const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

        if (diffDays < 7) {
          position.isNewJob = true
        }
      }

      vm.askQuestion = (position, event) => {
        event.preventDefault()
        event.stopPropagation()

        $uibModal.open({
          backdrop: 'static',
          templateUrl: 'contact-admin-modal.html',
          controller: 'ContactAdminController',
          controllerAs: 'ctrl',
          resolve: {
            selectedPosition: function() {
              return position
            },
          },
        })
      }

      vm.formatPqeToYears = qualificationDate => {
        return formatQualificationDateToPqe(qualificationDate)
      }

      vm.hideDropDown = () => {
        $scope.showClass = ''
      }

      vm.loadPrivateJobs = () => {
        $location.url('/opportunities')
      }

      vm.disabledToolTip = candidate => {
        if (candidate.approvalStatus === 'Locked')
          vm.toolTipText =
            'Your profile is locked, wait for reapproval to apply for jobs.'
        else if (candidate.resumes.length === 0)
          vm.toolTipText = 'Upload your CV to connect with employers.'
        else if (!candidate.user.phone)
          vm.toolTipText =
            'Please add your contact number in order to connect with firms.'
        return true
      }

      vm.updateProfileAlertStatus = (alertType, status) => {
        if (alertType === 'both') {
          vm.candidate.profileCvAlertCollapsed = status
          vm.candidate.profilePhoneAlertCollapsed = status
        } else {
          vm.candidate[alertType] = status
        }
      }

      vm.findPositionEmployerType = position => {
        return position.employerTypes.filter(
          ({name}) => name === 'Private Practice'
        ).length > 0
          ? '/images/Private.png'
          : '/images/Inhouse.png'
      }

      vm.initializeMatches = async () => {
        const user = await userService.getUser()
        vm.user = user
        const {data: locationsList} = await SharedApi.getAllLocations({
          supported: true,
          regions: true,
        })
        vm.locationsList = locationsList

        const {data: candidate} = await CandidateProfileApi.getUserProfile(
          user.id,
          {
            include: ['occupations', 'preferredContractTypes', 'school'],
          }
        )

        vm.candidate = candidate
        const {data} = await CandidateProfileApi.getUserProfile(user.id, {
          include: ['preferredLocations'],
        })
        vm.candidate.preferredLocations = data.preferredLocations
        const {data: userSetting} = await CandidateProfileApi.getUserSettings(
          vm.user.id
        )

        const {data: resumes} = await CandidateProfileApi.getUserResumes(
          user.id
        )

        vm.candidate.resumes = resumes
        const welcomePopupSetting = userSetting.find(({id}) => id === 1)

        if (
          vm.candidate.approvalStatus !== 'Locked' &&
          welcomePopupSetting &&
          welcomePopupSetting.userSettings.find(
            ({settingId}) => settingId === 1
          ).enable
        ) {
          $uibModal
            .open({
              templateUrl: 'welcome-modal.html',
              controller: 'WelcomeModalController',
              controllerAs: 'ctrl',
              resolve: {
                candidate: function() {
                  return vm.candidate
                },
              },
            })
            .result.then(
              () => {},
              () => {}
            )
        }

        vm.candidate.user.logoSrc = vm.candidate.user.profilePicture
          ? `${process.env.PUBLIC_BUCKET_URL}/user/${vm.candidate.user.id}/photo/${vm.candidate.user.profilePicture}`
          : 'images/defaultPic.jpg'

        vm.candidate.profileCvAlertCollapsed = false
        vm.candidate.profilePhoneAlertCollapsed = false
        vm.candidateAgent = await sharedProperties.getAgentDetails(
          vm.candidate.agent
        )

        const pqeYears = vm.formatPqeToYears(
          candidate.lawProfile.qualificationDate
        )
        vm.minPqe = pqeYears === '-' ? 0 : pqeYears - 1 <= 0 ? 0 : pqeYears - 1
        vm.maxPqe = pqeYears === '-' ? 11 : pqeYears + 1 <= 0 ? 0 : pqeYears + 1
        vm.filterPQE = `${vm.minPqe};${vm.maxPqe}`

        const {data: legalPracticeAreaList} = await SharedApi.getCategoryById(1)
        vm.legalPracticeAreaList = legalPracticeAreaList

        const {data: employerTypes} = await SharedApi.getCategoryById(2)

        vm.employerTypes = employerTypes.specialties.map(employerType =>
          Object.assign({ticked: true}, employerType)
        )
        vm.contractTypes = candidate.preferredContractTypes.map(contract =>
          Object.assign({ticked: true}, contract)
        )

        vm.occupations = candidate.occupations.map(occupation =>
          Object.assign({ticked: true}, occupation)
        )

        vm.candidateSpecialties = practiceAreaService.makeCandidatePracticeAreasHierarchy(
          candidate.category,
          vm.legalPracticeAreaList.specialties
        )

        vm.regionHierarchialListWithEuropeOnTop = locationsGenericService.makeCandidateLocationsHierarchy(
          vm.candidate.preferredLocations,
          vm.locationsList
        )

        vm.curLawyer = {
          user: {
            firstName: vm.user.firstName,
          },
          candidate: {
            profileCvAlertCollapsed: false,
            profilePhoneAlertCollapsed: false,
          },
        }
        await vm.onNumPerPageChange()
        $scope.$applyAsync()
      }

      vm.initializeMatches()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/matches/matches.ctrl.js